import { scrolldown, scrollUp } from "@/assets/images";
import { useDesignMaxTheme } from "@/packages";
import { Box, Center, Flex } from "@chakra-ui/react";
import { type ControlArrowsProps } from "./controlArrows.type";

export const ControlArrows = ({
    prevSlide,
    nextSlide,
    isNotFirstBtn = false,
    currentIdx,
    childLength,
}: ControlArrowsProps) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isLaptop } = MEDIAS();

    const shouldShowArrows = !isNotFirstBtn && currentIdx !== 1 && currentIdx !== childLength;

    return (
        <Flex
            position="absolute"
            display={isMobile ? "none" : "flex"}
            left="50%"
            bottom="20px"
            transform="translateX(-50%)"
            columnGap="16px"
        >
            {shouldShowArrows && (
                <>
                    <Center
                        w={isLaptop ? "56px" : "80px"}
                        h={isLaptop ? "56px" : "80px"}
                        onClick={prevSlide}
                        cursor="pointer"
                        borderRadius="16px"
                        _hover={{
                            background: "whiteAlpha.400",
                        }}
                    >
                        <Box w="100%" h="100%" background={`url(${scrollUp})no-repeat center/cover`} />
                    </Center>
                    <Center
                        w={isLaptop ? "56px" : "80px"}
                        h={isLaptop ? "56px" : "80px"}
                        onClick={nextSlide}
                        cursor="pointer"
                        borderRadius="16px"
                        _hover={{
                            background: "whiteAlpha.400",
                        }}
                    >
                        <Box w="100%" h="100%" background={`url(${scrolldown})no-repeat center/cover`} />
                    </Center>
                </>
            )}
        </Flex>
    );
};
